import { memo } from 'react';
import { Item } from '@/redux/back-dashboard-api';
import { ItemCategoryTextBadge } from '../badges/item-category';
import { ItemImage } from '../containers/item-image';

export const OrderItemListItem = memo<{
  item: Item;
}>(function OrderItemListItem({ item }) {
  return (
    <div className="flex w-full py-3 border-b space-x-4">
      <div className="w-14 h-14">
        <ItemImage item={item} />
      </div>

      <div className="max-w-full flex flex-col truncate">
        <p className="text-lg truncate">
          <b>{item.displayName}</b>
        </p>

        <p className="truncate">
          <ItemCategoryTextBadge category={item.category} />
        </p>
      </div>
    </div>
  );
});
